export function OrderTotal({ subtotal }) {
    const taxRate = 20
    const taxValue = subtotal * taxRate / 100

    return (
        <div className="cart-total ms-auto mt-2 p-4">
            <div className="d-flex justify-content-between border-bottom-sections">
                <p>Subtotal :</p>
                <p>${subtotal}</p>
            </div>
            <div className="d-flex justify-content-between border-bottom-sections mt-3">
                <p>Tax ({taxRate}%) :</p>
                <p>${taxValue}</p>
            </div>
            <div className="d-flex justify-content-between border-bottom-sections mt-3">
                <p>Discount :</p>
                <p>$0</p>
            </div>
            <div className="d-flex justify-content-between border-bottom-sections mt-3">
                <p>Shipping :</p>
                <p>Free</p>
            </div>
            <div className="d-flex justify-content-between mt-3 fs-3">
                <p>Total :</p>
                <p>${subtotal - taxValue}</p>
            </div>
        </div>
    )
}